import React from 'react'

import { PlusCircle as PlusCircleIcon } from 'react-feather'
import { Button } from '@material-ui/core'

import { useHistory } from 'react-router-dom'

import { Container, ContentHeader, Page, Permitted } from 'components'

import { KpiTable } from './components'

import { routes } from 'Routes'
import constants from 'constants/index'

const KpiMain = () => {
  const history = useHistory()

  const redirectToCreate = () => history.push(routes.kpi.new)

  return (
    <Page title="Monitoramento">
      <Container maxWidth={false}>
        <ContentHeader title="KPI">
          <Permitted
            tag={constants.permissions.MONITORING_MANAGEMENT_KPI.MANAGE}
          >
            <Button
              variant="contained"
              color="primary"
              startIcon={<PlusCircleIcon size={20} />}
              onClick={redirectToCreate}
              fullWidth
            >
              Criar
            </Button>
          </Permitted>
        </ContentHeader>
        <KpiTable />
      </Container>
    </Page>
  )
}

export default KpiMain
